import {MobXProviderContext} from 'mobx-react'
import React from "react";

export default function useMyStores() {
    const context = React.useContext(MobXProviderContext)
    return context || {};
}
